import { BooleanClaim } from 'supertokens-web-js/recipe/session';

export const PASSWORDLESS_CLAIM = new BooleanClaim({
  id: 'passwordless',
  refresh: async (): Promise<void> => {},
});
